export const language = {
  en: {
    "Inquiring": "Inquiring",
    "End of Inquiry": "End of Inquiry",
    "Inquiry#": "Inquiry#",
    "Create Time": "Create Time",
    "End Time": "End Time",
    "Reset": "Reset",
    "Query": "Query",
    "Please Enter": "Please Enter",
    "Please Select": "Please Select",
    "Start time～End time": "Start time～End time",
    "Create a New Request": "Create a New Request",
    "Inquiry Status": "Inquiry Status",
    "Numbers of Quoted Suppliers": "Numbers of Quoted Suppliers",
    "Maximum Price": "Maximum Price",
    "Operation": "Operation",
    "View": "View",
    "Receiving Region": "Receiving Region",
    "Expected Delivery Date": "Expected Delivery Date",
    "Inquiry End Time": "Inquiry End Time",
    "Additional Requirements": "Additional Requirements",
    "Reference Files": "Reference Files",
    "Add Pictures": "Add Pictures",
    "Contact Person": "Contact Person",
    "Contact Information": "Contact Information",
    "Select Supplier": "Select Supplier",
    "Supplier#": "Supplier#",
    "Supplier Name": "Supplier Name",
    "Return": "Return",
    "Submit": "Submit",
    "Country": "Country",
    "Province": "Province",
    "City": "City",
    "CNY": "CNY",
    "USD": "USD",
    "THB": "THB",
    "Please describe your requirements of product specifications, functions": "Please describe your requirements of product specifications, functions",
    "Please describe in detail the delivery address, specifications, packing, shipping, etc": "Please describe in detail the delivery address, specifications, packing, shipping, etc",
    "Product specifications, sample pictures, etc. (jpg, jpeg, png formats are supported, and up to three pictures can be uploaded)": "Product specifications, sample pictures, etc. (jpg, jpeg, png formats are supported, and up to three pictures can be uploaded)",
    "Confirm": "Confirm",
    "Requirement Details": "Requirement Details",
    "Quotation List": "Quotation List",
    "Status": "Status",
    "Inquiry Start Time": "Inquiry Start Time",
    "Product Requirements": "Product Requirements",
    "Volume": "Volume",
    "Expected Maximum Price": "Expected Maximum Price",
    "Trade Term": "Trade Term",
    "Delivery Requirements": "Delivery Requirements",
    "Selects the Supplier Visible List": "Selects the Supplier Visible List",
    "Please wait": "Please wait",
    "Quotation#": "Quotation#",
    "Select": "Select",
    "Batch Selected": "Batch Selected",
    "Supply Volume": "Supply Volume",
    "Unit Price": "Unit Price",
    "Unit": "Unit",
    "Total Price": "Total Price",
    "Quotation Status": "Quotation Status",
    "Please Select Quotation": "Please Select Quotation!",
    "Quoted": "Quoted",
    "Selected": "Selected",
    "Ended": "Ended",
    "Quote Information": "Quote Information",
    "Product Name (Brand Name)": "Product Name (Brand Name)",
    "Remark": "Remark",
    "Bargain": "Bargain",
    "Supplier Qualification": "Supplier Qualification",
    "Supplier Performance": "Supplier Performance",
    "Cooperation Times": "Cooperation Times",
    "Supplier Address": "Supplier Address",
    "The buyer wants to change your unit price to ": "The buyer wants to change your unit price to ",
    "Do you agree?": "Do you agree?",
    "Cancel": "Cancel",
    "Bidding Order Number": "Bidding Order Number",
    "Bid Status": "Bid Status",
    "End Time of Bidding": "End Time of Bidding",
    "Select Bidding Mode": "Select Bidding Mode",
    "Without setting the price ceiling, the supplier quotation with the lowest price is automatically selected.": "Without setting the price ceiling, the supplier quotation with the lowest price is automatically selected.",
    "Set the upper price limit of the expected unit price as": "Set the upper price limit of the expected unit price as",
    "When all suppliers quotations are higher than this price, the bidding fails.": "When all suppliers quotations are higher than this price, the bidding fails.",
    "CreationTime of Bidding": "CreationTime of Bidding",
    "Sourcing order number": "Sourcing order number",
    "Demand order status": "Demand order status",
    "CreationTime of Sourcing": "CreationTime of Sourcing",
    "End Time of Quote": "End Time of Quote",
    "Purchase Date Required": "Purchase Date Required",
    "Price Range": "Price Range",
    "Price Description": "Price Description",
    "Payment Terms": "Payment Terms",
    "Trade Terms": "Trade Terms",
    "Expected Mode of Transportation": "Expected Mode of Transportation",
    "Transport by Sea": "Transport by Sea",
    "Transport by Land": "Transport by Land",
    "Transport by Air": "Transport by Air",
    "Quotation Management": "Quotation Management",
    "Inquiry Quotation": "Inquiry Quotation",
    "Bidding Quotation": "Bidding Quotation",
    "Sourcing Reply": "Sourcing Reply",
    "Looking for A Quotation": "Looking for A Quotation",
    "Buyer": "Buyer",
    "Quotation": "Quotation",
    "Please Wait": "Please Wait",
    "Please Wait_1": "Please Wait_1",
    "Please Wait_2": "Please Wait_2",
    "Request for Quotation": "Request for Quotation",
    "Inquiry Purchasing": "Inquiry Purchasing",
    "Bidding Purchase": "Bidding Purchase",
    "Commodity Sourcing": "Commodity Sourcing",
    "Click or drag the file here to upload": "Click or drag the file here to upload",
    "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4",
    "Batch Import": "Batch Import",
    "Download Template": "Download Template",
    "Upload Import Table": "Upload Import Table",
    "Upload File": "Upload File",
    "Commodity Information": "Commodity Information",
    "Brand": "Brand",
    "Packaging Specification (If any)": "Packaging Specification (If any)",
    "After bidding, manually select a supplier.": "After bidding, manually select a supplier.",
    "All suppliers quotations are higher than your expected price ceiling, and the bidding failed.": "All suppliers quotations are higher than your expected price ceiling, and the bidding failed.",
    "Prohibit entering spaces": "Prohibit entering spaces",
    "Please Enter right Number": "Please Enter right Number",
    "Please Enter Right Number": "Please Enter Right Number",
    "Delete": "Delete",
    "Confirmed": "Confirmed",
    "Post a New Inquiry": "Post a New Inquiry",
    "OK": "OK",
    "End immediately": "End immediately",
    "Product demand": "Product demand",
    "Are you sure you want to end the inquiry immediately?": "Are you sure you want to end the inquiry immediately?",
    "Delivery demand": "Delivery demand",
    "Do you use": "Do you use",
    "】？": "】？",
    "Add Attachment": "Add Attachment",
    "Total price of goods": "Total price of goods",
    "Inquiry end time cannot be earlier than the current time.": "Inquiry end time cannot be earlier than the current time.",
    "Buyer Company": "Buyer Company",
    "Agree": "Agree",
    "DisAgree": "DisAgree",
    "(xls and xlsx formats are supported)": "(xls and xlsx formats are supported)",
    "Import template": "Import template",
    "Post a Quotation": "Post a Quotation",
    "Do you want to return?": "Do you want to return?",
    "Do you want to select these suppliers?": "Do you want to select these suppliers?",
    "Support Mode of Transportation": "Support Mode of Transportation",
    "Custom Payment Method": "Custom Payment Method",
    "Payment Method": "Payment Method",
    "Publish a New Bid": "Publish a New Bid",
    "Expected Currency": "Expected Currency",
    "Set the price ceiling of the expected total price as": "Set the price ceiling of the expected total price as",
    "Supplier has been selected": "Supplier has been selected",
    "line": "第",
    "No supplier selected in line": "行未选择供应商",
    "Please Select Suppliers.": "Please Select Suppliers.",
    "Bidding deadline": "Bidding deadline",
    "Bidding title": "Bidding title",
    "Others": "Others",
    "Please Upload": "Please Upload",
    "Publish a new Sourcing": "Publish a new Sourcing",
    "Purchasing Time Required": "Purchasing Time Required",
    "Demand Quantity": "Demand Quantity",
    "Do you want to end saucing immediately?": "Do you want to end saucing immediately?",
    "Searching for the source": "Searching for the source",
    "Product information filling error": "Product information filling error",
    "Quantity": "Quantity",
    "choose": "choose",
    "Suppliers Quotations": "Suppliers Quotations",
    "Save": "Save",
    "Add": "Add",
    "Export Products": "Export Products",
    "Supplier List": "Supplier List",
    "Please Select Price Ceiling Unit": "Please Select Price Ceiling Unit",
    "Unconfirmed": "Unconfirmed",
    "unit": "unit",
    "Bag": "Bag",
    "Bottle": "Bottle",
    "Box": "Box",
    "Carton": "Carton",
    "cm": "cm",
    "Dozen": "Dozen",
    "g": "g",
    "kg": "kg",
    "L": "L",
    "Layer": "Layer",
    "m": "m",
    "ml": "ml",
    "mm": "mm",
    "oz": "oz",
    "Pair": "Pair",
    "Pallet": "Pallet",
    "Pound": "Pound",
    "Ton": "Ton",
    "Product Category": "Product Category",
    "Create PO": "Create PO",
    "Quotation Record": "Quotation Record",
    "Record": "Record",
    "Purchase Order": "Purchase Order",
    "Please Select Doc Template": "Please Select Doc Template",
    "Template Name": "Template Name",
    "Pending on supplier side": "Pending on supplier side",
    "Supplier Unit Price": "Supplier Unit Price",
    "Continue Negotiating": "Continue Negotiating",
    "To Be Selected": "To Be Selected",
    "End Time of Inquiry Period": "End Time of Inquiry Period",
    "Inquiry End Time Cannot Be Earlier Than The Current Time.": "Inquiry End Time Cannot Be Earlier Than The Current Time.",
    "Do you want to continue negotiating?": "Do you want to continue negotiating?",
    "Terminate": "Terminate",
    "Do you want to terminate the inquiry immediately?": "Do you want to terminate the inquiry immediately?",
    "Yes": "Yes",
    "No": "No",
    "Click or drag the file here to upload. Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "Click or drag the file here to upload. Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4",
    "Supplier Confirmed Time": "Supplier Confirmed Time",
    "Buyer Confirmed Time": "Buyer Confirmed Time",
    "Quotation Time": "Quotation Time",
    "Supplier Replied Time": "Supplier Replied Time",
    "Buyer Replied Time": "Buyer Replied Time",
    "Reply": "Reply",
    "Please confirm": "Please confirm",
    "Submit Reply": "Submit Reply",
    "Inquiry List To Be Answered": "Inquiry List To Be Answered",
    "To be replied": "To be replied",
    "Buyer to be confirmed": "Buyer to be confirmed",
    "This inquiry ended, please contact buyer": "This inquiry ended, please contact buyer",
    "Title": "Title",
    "Sponsor": "Sponsor",
    "Export": "Export",
    "Copy": "Copy",
    "Type": "Type",
    "time": "time",
    "Explanation": "Explanation",
    "Confirmor": "Confirmor",
    "Confirm time": "Confirm time",
    "Lowest price": "Lowest price",
    "The current supplier quotation is not the lowest price. Please fill in the explanation.": "The current supplier quotation is not the lowest price. Please fill in the explanation.",
    "【": "【",
  },
  zh: {
    "Inquiring": "已发布",
    "End of Inquiry": "询价期结束",
    "Inquiry#": "询价单号",
    "Product Name (Brand Name)": "商品名称",
    "Create Time": "创建时间",
    "End Time": "截止时间",
    "Reset": "重置",
    "Query": "查询",
    "Please Enter": "请输入",
    "Start time～End time": "选择时间",
    "Create a New Request": "新建",
    "Inquiry Status": "询价单状态",
    "Numbers of Quoted Suppliers": "已报价供应商数",
    "Volume": "采购数量",
    "Expected Maximum Price": "期望价格上限",
    "Trade Term": "贸易方式",
    "Operation": "操作",
    "View": "查看",
    "Receiving Region": "收货地区",
    "Expected Delivery Date": "期望收货日期",
    "Additional Requirements": "补充说明描述",
    "Reference Files": "参考文件",
    "Add Attachment": "添加附件",
    "Contact Person": "联系人",
    "Contact Information": "联系方式",
    "Select Supplier": "选择供应商",
    "Supplier#": "供应商编号",
    "Supplier Name": "供应商名称",
    "Return": "返回",
    "Submit": "立即发布",
    "Country": "国家",
    "Province": "省",
    "City": "市",
    "CNY": "元",
    "USD": "美元",
    "THB": "泰铢",
    "Please describe your requirements of product specifications, functions": "请描述您对产品规格、功能、使用场景的要求",
    "Please describe in detail the delivery address, specifications, packing, shipping, etc": "请详细描述交货地址、产品规格、包装、运输等信息",
    "Product specifications, sample pictures, etc. (jpg, jpeg, png formats are supported, and up to three pictures can be uploaded)": "产品规格书、样品图等（支持jpg、jpeg、png等格式，最多可上传三张图片）",
    "Confirm": "确认",
    "Requirement Details": "需求详情",
    "Quotation List": "报价列表",
    "Status": "状态",
    "Inquiry Start Time": "询价发布时间",
    "Inquiry End Time": "询价期截止时间",
    "Product Requirements": "产品要求",
    "Maximum Price": "价格上限",
    "Delivery Requirements": "交货要求",
    "Selects the Supplier Visible List": "选择供应商",
    "Please wait": "等待报价 商家已收到您的寻源，正在报价中",
    "Quotation#": "报价单号",
    "Please Select Quotation": "请选择报价单!",
    "Select": "采用",
    "Batch Selected": "批量采用",
    "Supply Volume": "可供数量",
    "Unit Price": "单价",
    "Unit": "个",
    "Total Price": "总价",
    "Quotation Status": "报价单状态",
    "Quoted": "已报价",
    "Selected": "已采用",
    "Ended": "已结束",
    "Quote Information": "报价信息",
    "Remark": "备注",
    "Bargain": "议价",
    "Supplier Qualification": "供应商资质",
    "Supplier Performance": "供应商绩效",
    "Cooperation Times": "合作次数",
    "Supplier Address": "供应商地址",
    "The buyer wants to change your unit price to ": "采购商希望您的单价修改为",
    "Do you agree?": "请问您是否同意",
    "Cancel": "取消",
    "Bidding Order Number": "竞价单号",
    "Bid Status": "竞价单状态",
    "End Time of Bidding": "竞价截止时间",
    "Select Bidding Mode": "选择竞价方式",
    "Without setting the price ceiling, the supplier quotation with the lowest price is automatically selected.": "不设置价格上限，自动选择最低价格的供应商报价",
    "Set the upper price limit of the expected unit price as": "设置期望单价的价格上限为",
    "When all suppliers quotations are higher than this price, the bidding fails.": "当所有的供应商报价都高于这个价格时，竞价单竞价失败",
    "CreationTime of Bidding": "竞价发布时间",
    "Sourcing order number": "寻源单号",
    "Demand order status": "寻源单状态",
    "CreationTime of Sourcing": "寻源发布时间",
    "End Time of Quote": "报价截止时间",
    "Purchase Date Required": "需要采购日期",
    "Price Description": "价格说明",
    "Payment Terms": "付款条件",
    "Trade Terms": "贸易方式",
    "Expected Mode of Transportation": "期望运输方式",
    "Transport by Sea": "海运",
    "Transport by Land": "陆运",
    "Transport by Air": "空运",
    "Quotation Management": "报价管理",
    "Inquiry Quotation": "询价回复",
    "Bidding Quotation": "竞价回复",
    "Sourcing Reply": "寻源回复",
    "Looking for A Quotation": "发布中",
    "Quotation": "报价",
    "Please Wait": "等待发布询价",
    "Please Wait_1": "等待发布竞价",
    "Please Wait_2": "等待发布寻源",
    "Request for Quotation": "采购寻源",
    "Inquiry Purchasing": "询价采购",
    "Bidding Purchase": "竞价采购",
    "Commodity Sourcing": "商品寻源",
    "Click or drag the file here to upload": "点击或将文件拖拽到这里上传",
    "Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "支持扩展名:jpg、jpeg、png、word、excel、ppt、pdf、rar、zip、txt、flv、rmvb、mvb、mp4",
    "Batch Import": "批量导入商品",
    "Download Template": "下载模版",
    "Upload Import Table": "上传导入表",
    "Upload File": "上传文件",
    "Commodity Information": "商品信息",
    "Brand": "品牌",
    "Packaging Specification (If any)": "规格",
    "After bidding, manually select a supplier.": "竞价结束之后，手动选择一个供应商",
    "All suppliers quotations are higher than your expected price ceiling, and the bidding failed.": "所有供应商的报价都高于您的期望价格上限，竞价失败",
    "Prohibit entering spaces": "禁止输入空格",
    "Please Enter right Number": "请输入正确的数量",
    "Please Enter Right Number": "请输入正确的数字",
    "Please Select": "请选择",
    "Delete": "删除",
    "Confirmed": "已确认",
    "Post a New Inquiry": "发布新询价",
    "OK": "确认",
    "End immediately": "立即结束",
    "Product demand": "产品需求",
    "Are you sure you want to end the inquiry immediately?": "确定要立即结束询价吗?",
    "Delivery demand": "交货需求",
    "Do you use": "请问是否采用",
    "】？": "】的报价单？",
    "Total price of goods": "总价",
    "Inquiry end time cannot be earlier than the current time.": "询价期结束时间不能早于当前时间",
    "Buyer Company": "采购方",
    "Agree": "同意",
    "DisAgree": "不同意",
    "(xls and xlsx formats are supported)": "(支持xls、xlsx格式)",
    "Import template": "导入模板",
    "Post a Quotation": "发布报价",
    "Do you want to return?": "您确定要返回么?",
    "Do you want to select these suppliers?": "确定要采用这些供应商吗",
    "Support Mode of Transportation": "支持运输方式",
    "Price Range": "价格区间",
    "Custom Payment Method": "自定义付款方式",
    "Payment Method": "付款方式",
    "Publish a New Bid": "发布新竞价",
    "Expected Currency": "期望交易货币类型",
    "Set the price ceiling of the expected total price as": "设置期望总价的价格上限为",
    "Supplier has been selected": "已选择供应商",
    "line": "第",
    "No supplier selected in line": "行未选择供应商",
    "Please Select Suppliers.": "请选择供应商",
    "Bidding deadline": "竞价截止时间",
    "Bidding title": "竞价标题",
    "Others": "其他",
    "Please Upload": "请上传",
    "Publish a new Sourcing": "发布新寻源",
    "Purchasing Time Required": "需要采购时间",
    "Demand Quantity": "需求数量",
    "Do you want to end saucing immediately?": "确定要立即结束寻源吗?",
    "Searching for the source": "寻源中",
    "Product information filling error": "商品信息填写错误",
    "Quantity": "数量",
    "choose": "选择",
    "Suppliers Quotations": "供应商报价",
    "Save": "保存",
    "Add": "新建",
    "Export Products": "导出商品",
    "Supplier List": "供应商列表",
    "Please Select Price Ceiling Unit": "请选择期望价格上限单位",
    "Unconfirmed": "待确认",
    "unit": "个",
    "Bag": "袋",
    "Bottle": "杯",
    "Box": "盒",
    "Carton": "箱",
    "cm": "cm",
    "Dozen": "打",
    "g": "g",
    "kg": "kg",
    "L": "L",
    "Layer": "层",
    "m": "m",
    "ml": "ml",
    "mm": "mm",
    "oz": "盎司",
    "Pair": "对",
    "Pallet": "托",
    "Pound": "磅",
    "Ton": "吨",
    "Product Category": "商品分类",
    "Create PO": "新建进口单据",
    "Quotation Record": "报价记录",
    "Record": "记录",
    "Purchase Order": "采购单据",
    "Please Select Doc Template": "请选择单据模版",
    "Template Name": "模版名称",
    "Pending on supplier side": "待供应商回复",
    "Supplier Unit Price": "供应商报价",
    "Continue Negotiating": "继续沟通",
    "To Be Selected": "待采用",
    "End Time of Inquiry Period": "询价期结束时间",
    "Inquiry End Time Cannot Be Earlier Than The Current Time.": "询价期结束时间不能早于当前时间",
    "Do you want to continue negotiating?": "请确认是否继续沟通?",
    "Terminate": "终止",
    "Do you want to terminate the inquiry immediately?": "请确认是否直接终止该询价单?",
    "Yes": "是",
    "No": "否",
    "Click or drag the file here to upload. Extensions are supported: jpg, jpeg, png, word, excel, ppt, pdf, rar, zip, txt, flv, rmvb, mvb and mp4": "点击或将文件拖拽到这里上传支持扩展名:jpg、jpeg、png、word、excel、ppt、pdf、rar、zip、txt、flv、rmvb、mvb、mp4",
    "Supplier Confirmed Time": "卖家确认时间",
    "Buyer Confirmed Time": "买家确认时间",
    "Quotation Time": "卖家报价时间",
    "Supplier Replied Time": "卖家回复时间",
    "Buyer Replied Time": "买家回复时间",
    "Reply": "回复",
    "Please confirm": "请确认",
    "Submit Reply": "确认回复",
    "Inquiry List To Be Answered": "询价单待回复",
    "To be replied": "待回复",
    "Buyer to be confirmed": "待买家确认",
    "This inquiry ended, please contact buyer": "该询价单已到询价截止时间, 请联系买家",
    "Title": "询价标题",
    "Sponsor": "创建人",
    "Export": "导出",
    "Copy": "复制",
    "Type": "询价类型",
    "time": '次',
    "Explanation": "采用说明",
    "Confirmor": "确认人",
    "Confirm time": "确认时间",
    "Lowest price": "是否最低价",
    "The current supplier quotation is not the lowest price. Please fill in the explanation.": "当前供应商报价非最低价，请填写说明。",
    "【": "【",
  },
};
